import React from "react";
import { Button as BootstrapButton, Spinner } from "react-bootstrap";

const Button = ({
  title,
  variant,
  onClick,
  loading,
  buttonType,
  style,
  icon = null,
  disable,
}) => {
  return (
    <BootstrapButton
      type={buttonType}
      onClick={onClick}
      style={style}
      disabled={loading || disable}
      variant={variant}
      className="d-flex align-items-center justify-content-center"
    >
      {loading ? (
        <> <Spinner animation="border" size="sm" /></>
      ) : <>
        {icon}{title}
      </>}
    </BootstrapButton>
  );
};

Button.defaultProps = {
  title: "Button",
  buttonType: "button",
  loading: false,
  disable: false,
  variant: "primary",
};

// -------variant Color
// variant="primary"
// variant="secondary"
// variant="success"
// variant="danger"
// variant="warning"
// variant="dark"

export default Button;